import React, {
  FC,
  CSSProperties,
  useState,
  useCallback,
  ChangeEvent,
  useRef,
  // memo,
  // useEffect,
} from 'react';
import Message from '../PitBimWinMessage';
import yichu1 from '../../assets/images/yichu1.png';
import '../../styles/pitModuleRoamRoute.scss';
// import { Platform } from 'bimwin-api';
interface PitModuleRoamRouteProps {
  style?: CSSProperties;
  platform: any;
}
const PitModuleRoamRoute: FC<PitModuleRoamRouteProps> = ({ platform }) => {
  const body = useRef<any>(null);
  const [roaming, setroaming] = useState<any>([]);
  const [duration, setduration] = useState(10);
  const [isPaly, setisPaly] = useState(true);
  const addRoamingPoint = useCallback(() => {
    let roamingIndex = platform.bimwin.createWalkthroughKeyFrame();
    const position = roamingIndex.position;
    if (roaming.length > 0) {
      const preposition = roaming[roaming.length - 1].obj.position;
      if (
        position.x === preposition.x &&
        position.y === preposition.y &&
        position.z === preposition.z
      ) {
        Message.success('请移动视角以区别上一帧');
        return;
      }
    }
    let subscript: number;
    if (roaming.length == 0) {
      subscript = roaming.length + 1;
    } else {
      let name = roaming[roaming.length - 1].name;
      let index = name.indexOf('点') + 1;
      subscript = Number(name.slice(index)) + 1;
    }
    setroaming((pre: any) => {
      const arr = pre;
      arr.push({ obj: roamingIndex, name: '漫游点' + subscript });
      return [...arr];
    });
    setTimeout(() => {
      body.current.scrollTop = body.current.scrollHeight;
    }, 0);
  }, []);
  const playRomain = useCallback(async () => {
    if (roaming.length >= 2) {
      setisPaly(false);
      let arr = [];
      let tmArr = [0];
      let totalLen = 0;
      for (let i = 1; i < roaming.length; ++i) {
        let ll = roaming[i].obj.position.distanceTo(
          roaming[i - 1].obj.position
        );
        totalLen += ll;
        tmArr[i] = totalLen;
      }

      for (let i = 0; i < tmArr.length; ++i) {
        roaming[i].obj.time = tmArr[i] / totalLen;
      }

      for (const item of roaming) {
        arr.push(item.obj);
      }
      console.log('播放1', platform.bimwin.playWalkthroughAnimation);

      await platform.bimwin.playWalkthroughAnimation(arr, {
        timeScale: Number(duration),
      });
      setisPaly(true);
    }
  }, [roaming, duration]);
  // 停止播放
  const stopRomain = useCallback(() => {
    setisPaly(true);
    platform.bimwin.stopCameraAnimation();
  }, []);
  /** 删除 */
  const deleteRoamingPoint = useCallback(name => {
    const arr = roaming;
    roaming.forEach((item: any, index: number) => {
      if (item.name === name) {
        arr.splice(index, 1);
      }
    });
    setroaming(() => [...arr]);
  }, []);
  /** 清除漫游点 */
  const clearRomaingPoins = useCallback(() => {
    setroaming([]);
  }, []);
  const _setduration = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    console.log(e);
    setduration(Number(e.target.value));
  }, []);
  const roamingNode = roaming.map((item: any, index: number) => {
    return (
      <li
        className="pit-route-li pit-route-box pointer pit-selected-list"
        v-for="(item, index) in roaming"
        key={index}
      >
        <div className="pit-route-name">
          {index + 1} {item.name}
        </div>
        <div
          className="pit-route-button pointer"
          onClick={() => deleteRoamingPoint(item.name)}
        >
          <img className="pit-iocnimg" src={yichu1} alt="删除" />
        </div>
      </li>
    );
  });
  return (
    <div className="pit-panel-container pit-scroll-bar">
      <div className="pit-route-form">
        <div className="pit-route-title">
          <div className="pit-route-add pointer" onClick={addRoamingPoint}>
            <i className="pitfont pit-jiahao"></i>
            <span>添加漫游点</span>
          </div>
          {isPaly ? (
            <div
              className={`pit-route-control pointer ${
                roaming.length <= 1 ? 'pit-route-disabled' : ''
              }`}
              onClick={playRomain}
            >
              <i className="pitfont pit-24gl-play"></i>
              <span>播放</span>
            </div>
          ) : (
            <div className="pit-route-control pointer" onClick={stopRomain}>
              <span
                style={{
                  color: 'var(--font-hover-color)',
                  paddingRight: '5px',
                }}
              >
                | |
              </span>
              <span>停止</span>
            </div>
          )}
        </div>
        <div className="pit-route-body" ref={body}>
          {roaming.length <= 0 ? (
            <div className="pit-route-panel-tips">请添加漫游点</div>
          ) : (
            <ul className="pit-route-list pit-scroll-bar">{roamingNode}</ul>
          )}
        </div>
        <div className="pit-route-foot">
          <div className="pit-route-time pit-route-box pit-time-box">
            <span className="pit-route-time-name">漫游时间</span>
            <input
              placeholder="输入秒数，1-120"
              className="pit-route-number"
              type="number"
              min="1"
              max="120"
              value={duration}
              onChange={e => _setduration(e)}
            />
          </div>
        </div>
      </div>
      <div className="pit-route-clear-panter pointer">
        <div className="pit-route-clear-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="15.373"
            viewBox="0 0 14 15.373"
          >
            <defs></defs>
            <path
              className="a"
              d="M48.528,7.3h.565l1.189,10.816a.625.625,0,0,0,.62.557h8a.625.625,0,0,0,.62-.557L60.71,7.3h.565a.625.625,0,0,0,0-1.251H58.15V3.925a.625.625,0,0,0-.625-.625H52.277a.626.626,0,0,0-.625.625V6.05H48.526a.625.625,0,1,0,0,1.249ZM52.9,4.55h4v1.5h-4V4.55ZM52.277,7.3h7.177L58.342,17.422h-6.88L50.351,7.3h1.926Zm.127,8.421-.5-6.373a.625.625,0,1,1,1.246-.1l.5,6.373a.625.625,0,0,1-.574.672.483.483,0,0,1-.05,0A.621.621,0,0,1,52.4,15.721Zm2-.048V9.3a.625.625,0,0,1,1.251,0v6.373a.625.625,0,1,1-1.251,0Zm2-.048.5-6.375a.625.625,0,0,1,1.246.1l-.5,6.373a.624.624,0,0,1-.622.576.483.483,0,0,1-.05,0,.623.623,0,0,1-.574-.67Z"
              transform="translate(-47.9 -3.3)"
            />
          </svg>
          <span className="pit-route-clear" onClick={clearRomaingPoins}>
            删除全部
          </span>
        </div>
      </div>
    </div>
  );
};
export default PitModuleRoamRoute;
